var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUserSquare = function SvgIconUserSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.606 21.25h.894a1.75 1.75 0 0 0 1.75-1.75v-15a1.75 1.75 0 0 0-1.75-1.75h-15A1.75 1.75 0 0 0 2.75 4.5v15c0 .966.784 1.75 1.75 1.75h14.106M4.75 19.012a7.75 7.75 0 0 1 4-4.298 4.75 4.75 0 1 1 6.5 0 7.75 7.75 0 0 1 4 4.297V4.75H4.75zm12.428.238H6.822a5.75 5.75 0 0 1 10.356 0M12 8.5a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5",
    clipRule: "evenodd"
  })));
};
export default SvgIconUserSquare;